<template>
  <div>
    <div class="question">
      {{ questions[currentQuestion].questionText }}
    </div>
    <div :class="'answer-section'">
      <div
        :key="index"
        v-for="(option, index) in questions[currentQuestion].answerOptions"
        @click="handleAnswerClick(option.categoryCode)"
        :class="'answer-wrapper'"
      >
        <img
          :src="
            getDomain() +
              '/wp-content/themes/lkactiviteiten/assets/images/beroepentest/vraag' +
              (currentQuestion + 1) +
              '/vraag' +
              (currentQuestion + 1) +
              option.categoryCode +
              '.jpg'
          "
          :id="'vraag' + (currentQuestion + 1) + option.categoryCode"
          :alt="'Vraag ' + (currentQuestion + 1) + option.categoryCode"
          class="answer-img"
        />
        <button
          @click="handleAnswerClick(option.categoryCode)"
          class="btn btn-answer"
        >
          {{ option.answerText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    questions: {
      type: Array
    },
    currentQuestion: {
      type: Number
    }
  },

  methods: {
    handleAnswerClick(categoryCode) {
      this.$emit("emitToParent", categoryCode);
    },
    getDomain() {
      let href = window.location.href;
      let hrefArr = href.split("/");
      return hrefArr[0] + "//" + hrefArr[2];
    }
  }
};
</script>

<style scoped>
.answer-section:hover button,
.answer-section:hover .answer-wrapper {
  cursor: pointer;
}

.answer-section {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}

.answer-wrapper {
  display: flex;
  flex-direction: column;
  width: 33.33%;
}
</style>
